import React, { useState } from "react";
import { Box } from "@mui/material";
import AddressEntryForm from "../AddressEntryForm";
import { saveAddressOnly } from "../../utils/utils";

/**
 * Inline address editor for account-details Location section.
 * Persists via saveAddressOnly; parent runs rep recalc in onAddressSaved.
 */
export default function EditAddressForm({ initialAddress, onAddressSaved }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (payload) => {
    try {
      setSaving(true);
      setError(null);
      await saveAddressOnly(payload);
      if (typeof onAddressSaved === "function") {
        onAddressSaved(payload);
      }
    } catch (err) {
      console.error("Failed to save address", err);
      setError("Failed to save address. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <AddressEntryForm
        hint="Update your address to refresh your congressional district and representatives."
        submitLabel="Save Address"
        onSubmit={handleSubmit}
        loading={saving}
        externalError={error}
        initialAddress={initialAddress}
        submitAlign="right"
      />
    </Box>
  );
}
